class DropAHint extends HTMLElement {
  static endpoint = 'https://app.cecejewellery.com/de1e8ad3403d6a3f52bb5dc863b910d5';

  constructor() {
    super();
    this.trigger = this.querySelector('[data-hint-trigger]');
    this.dialog = this.querySelector('[data-hint-dialog]');
    this.closeButtons = this.querySelectorAll('[data-hint-close]');
    this.form = this.querySelector('[data-hint-form]');
    this.submitButton = this.querySelector('[data-hint-submit]');
    this.successMessage = this.querySelector('[data-hint-success]');
    this.errorMessage = this.querySelector('[data-hint-error]');

    this.trigger?.addEventListener('click', this.open.bind(this));
    this.closeButtons.forEach((button) => button.addEventListener('click', this.close.bind(this)));
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  open() {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
  }

  close() {
    if (!this.dialog?.open) return;

    this.dialog.classList.add('drop-a-hint--closing');
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.dialog.classList.remove('drop-a-hint--closing');
      this.dialog.close();
    };
    this.dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 400);
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.form || this.classList.contains('drop-a-hint--loading')) return;

    this.errorMessage?.setAttribute('hidden', '');
    this.setLoading(true);

    try {
      const formData = new FormData(this.form);
      const data = new URLSearchParams(formData);
      data.append('product_url', window.location.href);

      const request = new Request(DropAHint.endpoint, {
        method: 'POST',
        body: data,
      });

      const response = await fetch(request);
      if (!response.ok) throw new Error(`Drop-a-hint request failed with status ${response.status}`);

      this.form.hidden = true;
      this.successMessage?.removeAttribute('hidden');
    } catch (error) {
      this.errorMessage?.removeAttribute('hidden');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.classList.toggle('drop-a-hint--loading', isLoading);
    this.submitButton?.toggleAttribute('disabled', isLoading);
  }
}

customElements.define('drop-a-hint', DropAHint);
